// @flow

import Loadable from "react-loadable";
import DynamicImportLoader from "app/components/atoms/DynamicImportLoader/DynamicImportLoader";
import type { InteractivesMenuItemConfig } from "../interactives-list";
import { ALL_USER_GROUPS_BUT_GUESTS } from "../../utils/constants";
import DisplayImage from "./image.png";

const description =
  "The Good Weekend supplement's weekly quiz, rebuilt for our online mastheads.";
const CONFIG: InteractivesMenuItemConfig = {
  name: "Good Weekend quiz",
  id: "good-weekend-quiz",
  groupsWithAccess: ALL_USER_GROUPS_BUT_GUESTS,
  linkPrefix: "/interactives",
  tags: ["Configurable"],
  description,
  image: DisplayImage,
  cradleIframeUrlRoot:
    "https://www.smh.com.au/interactive/modules/good-weekend-quiz/index.html?resizable=true",
  ConfigComponent: Loadable({
    delay: 200, // See 'Avoiding Flash Of Loading Component': https://github.com/jamiebuilds/react-loadable
    loader: () =>
      import(/* webpackChunkName: "GoodWeekendQuizConfigTool" */ "app/components/tools/GoodWeekendQuizConfigTool/GoodWeekendQuizConfigTool"),
    loading: DynamicImportLoader,
    modules: ["GoodWeekendQuizConfigTool"]
  })
};

export default CONFIG;
